<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="Service reminder " 
[backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field">
  </div>
  </ng-template>
</sm-title-bar>

<div class="bradcamp_inventory">
  <div class="row">
    <div class="col-sm-3">
      <div class="overall_count_s">
      <p>Active</p>
      <h3>113</h3>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="overall_count_s" style="border-right: none !important;">
      <p>Inactive/paused</p>
      <h3>62</h3>
      </div>
    </div>
  
    <div class="col-sm-6">
      <div class="view_items_btn">
        <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="openreminder()">
        <mat-icon>add</mat-icon>  New reminder
        </button>
      </div>
    </div>
  </div>
  </div>


<table mat-table [dataSource]="dataSource" class="mat-elevation-z1 full-width">

  <!-- Name -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>

  <!-- Trigger Date -->
  <ng-container matColumnDef="triggerDate">
    <th mat-header-cell *matHeaderCellDef>Trigger date</th>
    <td mat-cell *matCellDef="let row">{{ row.triggerDate }}</td>
  </ng-container>

  <!-- Trigger Time -->
  <ng-container matColumnDef="triggerTime">
    <th mat-header-cell *matHeaderCellDef>Trigger time</th>
    <td mat-cell *matCellDef="let row">{{ row.triggerTime }}</td>
  </ng-container>

  <!-- Notification -->
  <ng-container matColumnDef="notification">
    <th mat-header-cell *matHeaderCellDef>Notification / notes</th>
    <td mat-cell *matCellDef="let row">{{ row.notification }}</td>
  </ng-container>

  <!-- Frequency -->
  <ng-container matColumnDef="frequency">
    <th mat-header-cell *matHeaderCellDef>Frequency</th>
    <td mat-cell *matCellDef="let row">{{ row.frequency }}</td>
  </ng-container>

  <!-- Status -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let row">
      <span class="status" [ngClass]="row.status.toLowerCase()">
        {{ row.status }}
      </span>
    </td>
  </ng-container>

  <!-- Created On -->
  <ng-container matColumnDef="createdOn">
    <th mat-header-cell *matHeaderCellDef>Created on</th>
    <td mat-cell *matCellDef="let row">{{ row.createdOn }}</td>
  </ng-container>

  <!-- Actions -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="edit(row)">
          <mat-icon class="material-icons-outlined">edit</mat-icon>
          <span>Edit</span>
        </button>

        <button mat-menu-item (click)="pause(row)">
          <mat-icon class="material-icons-outlined">pause</mat-icon>
          <span>Pause</span>
        </button>

        <button mat-menu-item  (click)="delete(row)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>



